import { baseColors } from './baseColors';
const fill = {
    background: baseColors.grayscale['0000'],
    subtle: baseColors.grayscale['0075'],
    strong: baseColors.grayscale['0750'],
    disabled: {
        subtle: baseColors.grayscale['0150'],
    },
    critical: {
        subtle: baseColors.red.lighter,
        strong: baseColors.red.dark,
    },
    info: {
        subtle: baseColors.blue.lightest,
        strong: baseColors.blue.dark,
    },
    caution: {
        subtle: baseColors.yellow.lightest,
        strong: baseColors.yellow.darker,
    },
    celebratory: {
        subtle: baseColors.green.lightest,
        strong: baseColors.green.darker,
    },
};
const stroke = {
    neutral: {
        text: {
            highContrast: {
                on: {
                    background: baseColors.grayscale['1000'],
                    subtle: baseColors.grayscale['1000'],
                    strong: baseColors.grayscale['0000'],
                },
            },
            primary: {
                on: {
                    background: baseColors.grayscale['0750'],
                    subtle: baseColors.grayscale['0750'],
                    strong: baseColors.grayscale['0000'],
                },
            },
            secondary: {
                on: {
                    background: baseColors.grayscale['0625'],
                    subtle: baseColors.grayscale['0625'],
                    strong: baseColors.grayscale['0075'],
                },
            },
            tertiary: {
                on: {
                    background: baseColors.grayscale['0500'],
                    subtle: baseColors.grayscale['0625'],
                    strong: baseColors.grayscale['0150'],
                },
            },
        },
        border: {
            interaction: {
                primary: {
                    on: {
                        background: baseColors.grayscale['0750'],
                    },
                },
                secondary: {
                    on: {
                        background: baseColors.grayscale['0500'],
                    },
                },
                tertiary: {
                    on: {
                        background: baseColors.grayscale['0375'],
                    },
                },
            },
            decoration: {
                on: {
                    background: baseColors.grayscale['0150'],
                    subtle: baseColors.grayscale['0150'],
                    strong: baseColors.grayscale['0250'],
                },
            },
        },
    },
    focused: {
        outline: {
            on: {
                background: baseColors.blue.dark,
                subtle: baseColors.blue.dark,
            },
        },
    },
    critical: {
        text: {
            on: {
                background: baseColors.red.dark,
                subtle: baseColors.red.darker,
            },
        },
    },
    info: {
        text: {
            on: {
                background: baseColors.blue.dark,
                subtle: baseColors.blue.dark,
            },
        },
    },
    caution: {
        text: {
            on: {
                background: baseColors.yellow.darker,
                subtle: baseColors.yellow.darker,
            },
        },
    },
    celebratory: {
        text: {
            on: {
                background: baseColors.green.dark,
                subtle: baseColors.green.darker,
            },
            highContrast: {
                on: {
                    subtle: baseColors.green.darkest,
                },
            },
        },
    },
    disabled: {
        text: {
            on: {
                background: baseColors.grayscale['0500'],
                subtle: baseColors.grayscale['0625'],
            },
        },
    },
};
export const paletteColorsLightMode = {
    fill,
    stroke,
};
//# sourceMappingURL=paletteColorsLightMode.js.map